/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconArrowAutofitUp = createReactComponent("outline", "arrow-autofit-up", "IconArrowAutofitUp", [["path", { "d": "M12 4h-6a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h8", "key": "svg-0" }], ["path", { "d": "M18 20v-17", "key": "svg-1" }], ["path", { "d": "M15 6l3 -3l3 3", "key": "svg-2" }]]);

export { IconArrowAutofitUp as default };
//# sourceMappingURL=IconArrowAutofitUp.mjs.map
